import { SITE_ORIGIN, LOCALES } from '@/config/site';

/**
 * @param {string} localeCode en | in | es | pt | id
 * @param {string} segment 不含斜杠，如 ''、'download'、'blog/slug'
 */
export function localeUrl(localeCode, segment) {
	const seg = (segment || '').replace(/^\/+|\/+$/g, '');
	if (localeCode === 'en') {
		if (!seg) return '/';
		return `/${seg}/`;
	}
	const loc = LOCALES.find((l) => l.code === localeCode);
	const prefix = loc && loc.path ? `/${loc.path}` : '';
	if (!seg) return `${prefix}/`;
	return `${prefix}/${seg}/`;
}

export function absoluteUrl(localeCode, segment) {
	const path = localeUrl(localeCode, segment);
	return `${SITE_ORIGIN}${path === '/' ? '/' : path}`;
}

/** PDF：每页 hreflang */
export function buildHreflangLinkTags(segment) {
	const seg = (segment || '').replace(/^\/+|\/+$/g, '');
	const locales = seg ? LOCALES.filter((l) => l.code === 'en') : LOCALES;
	const lines = locales.map((l) => {
		const href = absoluteUrl(l.code, segment);
		return `<link rel="alternate" hreflang="${l.hreflang}" href="${href}" />`;
	});
	lines.push(`<link rel="alternate" hreflang="x-default" href="${absoluteUrl('en', seg)}" />`);
	return lines.join('\n');
}
